import * as React from 'react';
import { mergeRight } from 'ramda';
import { icon as Icon } from '../data/icon';

import setting from '../setting';

export function IconComp({ style, icon, onMouseDown, onDoubleClick }: {
    style: React.CSSProperties,
    icon: Icon,
    onDoubleClick: () => void,
    onMouseDown: (e: React.MouseEvent<HTMLElement | SVGSVGElement, MouseEvent>) => void,
}) {
    if (Icon.isBaseIcon(icon)) {
        if (icon.icon === null) {
            return (
            <Play style={style}
                onMouseDown={onMouseDown}
                onDoubleClick={onDoubleClick}
            />);
        } else {
            return (
            <img src={`${setting.補充資料按鈕路徑}${icon.icon}`} style={style} draggable={false}
                onMouseDown={onMouseDown}
                onDoubleClick={onDoubleClick}
            />);
        }
    } else {
        return (
        <div
            style={mergeRight(style, {
                width: `${icon.width}px`,
                height: `${icon.height}px`,
                backgroundColor: '#f003',
            })}
            onMouseDown={onMouseDown}
            onDoubleClick={onDoubleClick}
        />);
    }
}

function Play({ style, onDoubleClick, onMouseDown }: {
    style: React.CSSProperties,
    onDoubleClick: () => void,
    onMouseDown: (e: React.MouseEvent<HTMLElement | SVGSVGElement, MouseEvent>) => void,
}) {
    return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"
        style={mergeRight({
            width: '90px',
            height: '90px',
        }, style)}
        onDoubleClick={onDoubleClick}
        onMouseDown={onMouseDown}
    >
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
        <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"/>
    </svg>);
}
